import React, { useEffect, useState } from 'react';
import { getToDate } from '../../../components/Chart/utils';
import { getWaterTariff } from '../../../api/api';

const WaterTariffCost = ({ device_id, from }) => {
  const [estimatedPrice, setEstimatedPrice] = useState();
  const to = getToDate(from);

  useEffect(() => {
    if (from && to) {
      const getEstimatedPrice = async () => {
        const params = {
          device_id,
          from: from,
          to: to,
        };
        const price = await getWaterTariff(params);
        setEstimatedPrice(price);
      };
      getEstimatedPrice();
    }
  }, [from, to, device_id]);

  return estimatedPrice !== undefined ? <p className="text-gray-800 text-lg">~ {estimatedPrice.toLocaleString('ru')} ₽ </p> : null;
};

export default WaterTariffCost;
